import React, { useState, useEffect,useRef } from "react";
import ReactPaginate from "react-paginate";
import axios from 'axios';
import { getUserId,aPIURL } from '../../utils/common';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useReactToPrint } from 'react-to-print';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import AvtLineChart from "./AvtLineChart.js";
import AVTBarChart from "./AVTBarChart.js";


const FuelDetails = () => {

  const [sdate,setSdate] = useState();
  const [edate,setEdate] = useState();    
  const [frDdate,setFrDate] = useState();
  const [toDate,setToDate] = useState();  
  let [min_Date,setMin_Date]= useState("");
  let [max_Date,setMax_Date]= useState("");  
  let slitems =    [];
  let [fuelLabelData, setFuelLabelData] = useState(slitems);   
  let slditems =  [];
  let [fuelCountData, setFuelCountData] = useState(slditems); 
  
  const fileType ="xlsx";
  const tableRef = useRef(null);
  const [imeiNo,setImeiNo]= useState("0"); 
  const [post, setPost] = useState([]);
   
  const API_URL=aPIURL();
  const AccountID =getUserId(); 
  const [vehicleData,setVehicleData] =useState([]);
  const [number, setNumber] = useState(1); // No of pages
  const [postPerPage] = useState(10); 
  const [order, setOrder] = useState("ASC");
  const [activeTab, setActiveTab] = useState("tab1");

             
useEffect(() => 
{           
            setMinMaxDate();
            //Bind Drop Down for vehicle List
            const vurls=API_URL+`VehicleList/?AccountID=${AccountID}&TypeID=3`;    
           
            axios.get(vurls).then(response =>
                 {                  
                        const updatedList =  response.data.data.filter((curElem) => {
                       
                        return curElem.status === "Enabled";
                  });   
                        setVehicleData(updatedList);                    
    
                 }).catch(function(error) 
                 {  
                      console.log(error.message); 
                 });
}, []);
  
  const lastPost = number * postPerPage;
  const firstPost = lastPost - postPerPage;
  const currentPost = post.slice(firstPost, lastPost);
  const PageCount = Math.ceil(post.length / postPerPage);

 
 const setMinMaxDate = () => 
 {
    const date = new Date();
    date.setDate(date.getDate() - 90);
    setMin_Date(date.toISOString().split('T')[0]);

    const mdate = new Date();
    mdate.setDate(mdate.getDate());
    setMax_Date(mdate.toISOString().split('T')[0]);

    const fdate = new Date();
    fdate.setDate(fdate.getDate() - 14);
    setFrDate(fdate.toISOString().split('T')[0]);
    setSdate(fdate.toISOString().split('T')[0]);

    //set today date as default date starts
    var now = new Date();
    var month = (now.getMonth() + 1);               
    var day = now.getDate();
    if (month < 10) 
    month = "0" + month;
    if (day < 10) 
    day = "0" + day;
    var today = now.getFullYear() + '-' + month + '-' + day;
    setEdate(today);
    //set today date as default date ends    
 };
//Filter start

// Calculate Difference in days between two dates
const getDateDifferenceInDays = (date1, date2) => 
{
  const d1 = new Date(date1);
  const d2 = new Date(date2);

  // Get difference in milliseconds
  const diffInMs = Math.abs(d2 - d1);

  // Convert milliseconds to days
  return Math.floor(diffInMs / (1000 * 60 * 60 * 24));
};

const FilterGrid=()=>
{         
          const diffdays=getDateDifferenceInDays(sdate,edate);
          if(imeiNo==="0")
          {
                          setPost([]);
                          setFuelLabelData([]);
                          setFuelCountData([]);    
                          toast.error("Please Select Vehicle.");                                 
          }
          else if(diffdays>14)
          {
                      setPost([]);
                      setFuelLabelData([]);
                      setFuelCountData([]);
                      toast.error("Please Select Date Range not more than 15days.");
          }
          else
          {
                       setPost([]);
                       const fuelurls1= API_URL + "FuelProcessdata";  
                       const fuelparams1 = JSON.stringify({
                         "fromdate": sdate ,
                         "todate": edate , 
                         "imei": imeiNo,
                         "value": 1         
                        });     
                                          
                        axios.post(fuelurls1, fuelparams1, { "headers": {"content-type": "application/json", },})
                        .then(function (response) 
                        {
                                 if(response.data.data.length>0)
                                 {
                                  setPost(response.data.data);
                                  //to array start
                                  const labels1 = response.data.data.map(item => item.label);
                                  const values1 = response.data.data.map(item => item.value);
                                  setFuelLabelData(labels1);
                                  setFuelCountData(values1);                                  
                                  //to array end
                                 }
                                 else
                                 {
                                      setPost([]);
                                      setFuelLabelData([]);
                                      setFuelCountData([]);    
                                      toast.error("No Data Found."); 
                                 }
                         })
                         .catch(function (error) 
                         {
                                   setPost([]);
                                   setFuelLabelData([]);
                                   setFuelCountData([]);    
                                   toast.error("No Data Found..");                              
                         });   
                  }                   
}
const ResetList=()=>
{
      setImeiNo("0");
      setSdate(today);
      setEdate(today);
      setPost([]);
      setFuelLabelData([]);
      setFuelCountData([])
}

//Filterb End
const ChangePage = ({ selected }) => {
        
        setNumber(selected+1);
};

const sorting=(col)=>
{
    try
    {
      if(order==="ASC")
      {
            const sorted=[...post].sort((a,b)=>
            a[col].toLowerCase() > b[col].toLowerCase() ? 1: -1);
            setPost(sorted);
            setOrder("DSC");
      }
      if(order==="DSC")
      {
              const sorted=[...post].sort((a,b)=>
              a[col].toLowerCase() < b[col].toLowerCase() ? 1: -1);
              setPost(sorted);
              setOrder("ASC");
      }
    }
    catch(error) 
    {
      console.log(error.message);
    }             
}
const ChangeVehicleNo = (e) => {
         
        setImeiNo(e.target.value);
        setSdate(frDdate);
        setEdate(today);        
}

const exportToCSV=()=>
{
      const newPost = post.map(({ address,contactNumber,countryId,countryName,deviceID,driverID,expiryDate,fasTag,imgPath,regYear,stateID,stateName,vehicleID,vehicleTypeID,vin, ...rest }) => rest);
      const ws= XLSX.utils.json_to_sheet(newPost);        
      var wscols = [ {wch:5} , {wch:20}, {wch:20}, {wch:20},{wch:20}, {wch:20}, {wch:20}, {wch:20},{wch:20}, {wch:20} ];
      var wsrows = [ {hpx: 30} ];
      ws['!cols'] = wscols;
      ws['!rows']=wsrows;
           
      let Heading = [['TimeStamp','Fuel Value']];
      const wb={Sheets:{Fuel:ws},SheetNames:["Fuel"]};
      XLSX.utils.sheet_add_aoa(ws, Heading);     
      const excelBuffer= XLSX.write(wb,{bookType:"xlsx",type:"array"});
      const data= new Blob([excelBuffer],{type:fileType});
      FileSaver.saveAs(data,"AvtFuelReport"+".xlsx");      
}
const exportDownload = e => 
{  
 const value = e.target.value;   

if(value==="Excel")
{
    exportToCSV();    
    
}
if(value==="PDF")
{
        handlePrint(null, () => tableRef.current);
}}

const handlePrint = useReactToPrint({
  documentTitle: "Fuel Details",
  onBeforePrint: () => console.log("before printing..."),
  onAfterPrint: () => console.log("after printing..."),
  removeAfterPrint: true,
});

const SDatechangeHandler = (e) => 
{   
    setSdate(e.target.value);   
    const date = new Date(e.target.value);
    date.setDate(date.getDate() + 14);
    if(date.toISOString().split('T')[0]>today)
    {
        setEdate(today);
    }
    else
    {
        setEdate(date.toISOString().split('T')[0]);
    }
        
    
} 
const EDatechangeHandler = (e) => 
{   
    setEdate(e.target.value);    
}
         
  //mindate date range start
  let minDatefr = new Date()
  minDatefr.setDate(minDatefr.getDate() - 90)
  var ddfr = minDatefr.getDate();
  var mmfr = minDatefr.getMonth() + 1; 
  var yyyyfr = minDatefr.getFullYear();

  if (ddfr < 10)
  {
      ddfr = '0' + ddfr
  }
  if (mmfr < 10) 
  {
      mmfr = '0' + mmfr
  }
  minDatefr = yyyyfr + '-' + mmfr + '-' + ddfr;
  //mindate date range end
  //max date start
  var today = new Date();
  var dd = today.getDate();
  var mm = today.getMonth() + 1; 
  var yyyy = today.getFullYear();

  if (dd < 10) {dd = '0' + dd}
  if (mm < 10) {mm = '0' + mm}
  today = yyyy + '-' + mm + '-' + dd;     
  //max date end
 
  return (
    <>
      <div className="top-bar clearfix">
      <div className="row">       
      <div className="col-md-4">
      <h2> Fuel Details</h2></div>
      <div className="col-md-8 text-right">     
      <select  onChange={exportDownload}  className="btn btn-primary" name="Download" >
      <option value={"Download"}>Download</option>    
      <option value={"Excel"}>Excel</option>    
      <option value={"PDF"}>PDF</option>  
      </select>
      </div></div></div>

 {/* Filter data start  */}
    
 <div className="container-fluid p-3">
  <div class="card mb-3 shadow no-border border-0">
  <div class="card-body">
    <div class="row align-items-end">  
    <div class="col-sm-3 col-lg-2">Vehicle#
        <select className="form-control"  name="DVehicleNo" value={imeiNo} onChange={ChangeVehicleNo} >
        <option value={0}>Select</option>
        {vehicleData.map((e, key) => {
        return <option key={key} value={e.imeiNumber}>{e.vehicleNumber}</option>;
        })}
        </select>         
    </div>
    <div class="col-sm-3 col-lg-2">From Date<input class="form-control" aria-label="SDate" onChange={SDatechangeHandler} value={sdate} min={min_Date} max={max_Date}  type="date" />
    </div>
    <div class="col-sm-3 col-lg-2">To Date<input class="form-control" aria-label="EDate" onChange={EDatechangeHandler} value={edate} min={min_Date} max={max_Date}  type="date" />
    </div>       
      <div class="col-sm-4 col-lg-2">
      <button type="button" class="btn btn-primary2 mt-20" tabindex="6" id="btnTripAdvancedSearchNew" onClick={FilterGrid} >Search</button>
      <button type="button" class="btn btn-secondary mt-20" id="btnTripResetAdvancedSearchNew" tabindex="7" onClick={ResetList}>Reset
      </button></div></div>    
  </div></div>
      {/* Filter data end  */}
      <div className="container-fluid p-3">  
         
      <div class="card mb-3 shadow no-border border-0">
        <div className="card-header p-0">
          <nav>
  <div class="nav nav-tabs" id="nav-tab" role="tablist">
    <button class="nav-link active" id="nav-home-tab" data-bs-toggle="tab" data-bs-target="#nav-home" type="button" role="tab" aria-controls="nav-home" aria-selected="true">Chart</button>
    <button class="nav-link" id="nav-profile-tab" data-bs-toggle="tab" data-bs-target="#nav-profile" type="button" role="tab" aria-controls="nav-profile" aria-selected="false">Tabular</button>    
  </div>
</nav>
        </div>
      <div class="card-body" >
        <div class="tab-content" id="nav-tabContent">
  <div class="tab-pane fade show active" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">
<div className="row">
  <div className="col-12 col-lg-6">
    <AvtLineChart style={{height:"350px"}} sditems={fuelLabelData}  saleitems={fuelCountData}  label="AVT Fuel Details (Line Chart)"/> 
  </div>
  <div className="col-12 col-lg-6">
    <AVTBarChart style={{height:"350px"}} sditems={fuelLabelData}  saleitems={fuelCountData}  label="AVT Fuel Details (Bar Chart)"/>     
  </div>
</div>

  </div>
  <div class="tab-pane fade" id="nav-profile" role="tabpanel" aria-labelledby="nav-profile-tab">
    <div className="row">
  <div className="col-12 col-lg-6">
      <table ref={tableRef} class="table table-striped table-bordered table-hover" style={{width:"100%", padding:"20px"}}>
      <thead>
      <tr>
       <th style={{textAlign:"center"}} width="5%">S.No.</th>{/**/}
      <th width="50%" onClick={()=>sorting("label") } style={{textAlign:"center","cursor": "pointer"}}>Time Stamp &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th> 
      <th width="45%" onClick={()=>sorting("value") } style={{textAlign:"center","cursor": "pointer"}}>Fuel Value </th>                
      </tr>
      </thead>
      <tbody>
      {currentPost.map((Val,index) =>
       {
              return (
              <>
              <tr >
              <td style={{ textAlign: "center" }}>{firstPost + index+ 1}</td>
              <td style={{ textAlign: "center" }}>{Val.label}</td>
              <td style={{ textAlign: "center" }}>{Val.value}</td>             
              </tr>
              </>
              );
       })}
       </tbody>
       </table>
       <ReactPaginate  previousLabel={"<<"}  nextLabel={">>"} pageCount={PageCount}  onPageChange={ChangePage} disableInitialCallback={true} initialPage={0}  containerClassName={'pagination justify-content-end'} pageClassName={'page-item'}  pageLinkClassName={'page-link'}
       previousClassName={'page-item'} previousLinkClassName={'page-link'}  nextClassName={'page-item'}  nextLinkClassName={'page-link'} breakClassName={'page-item'}  breakLinkClassName={'page-link'}  activeClassName={'active'}>
      </ReactPaginate>
       

  </div>
  <div className="col-12 col-lg-6">
   </div></div> </div>  </div></div></div></div></div>
      <ToastContainer position="bottom-right" autoClose={4000} theme="light"/> 
    </>
  );
};
export default FuelDetails;


